<template>
  <div class="etms-router-body">
    <span v-for="tag in taglist" :key="tag.value" @click="tagClick(tag)" :class="[tag.class,'tag-span']">{{tag.label}}({{tag.totalnum}})</span>
    <el-button size="mini" type="primary" icon="el-icon-arrow-down" @click="searchshow=!searchshow">更多搜索条件</el-button>
    <el-button size="mini" type="primary" icon="el-icon-upload">抓取单号</el-button>
    <el-button size="mini" type="primary" icon="el-icon-download">导出运单</el-button>
    <el-dropdown @command="handleCommand">
      <el-button size="mini" type="primary">
        更多操作<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="a">删除单号</el-dropdown-item>
        <el-dropdown-item command="b">移至暂存</el-dropdown-item>
        <el-dropdown-item command="b">拆分运单</el-dropdown-item>
        <el-dropdown-item command="b">合并运单</el-dropdown-item>
        <el-dropdown-item>移至回收站</el-dropdown-item>
        <el-dropdown-item>修改渠道</el-dropdown-item>
        <el-dropdown-item>修改目的国家</el-dropdown-item>
        <el-dropdown-item>修改起运机场</el-dropdown-item>
        <el-dropdown-item>修改目的机场</el-dropdown-item>
        <el-dropdown-item>修改起运港</el-dropdown-item>
        <el-dropdown-item>修改目的港</el-dropdown-item>
        <el-dropdown-item>修改起运仓库</el-dropdown-item>
        <el-dropdown-item>修改目的仓库</el-dropdown-item>
        <el-dropdown-item>彻底删除</el-dropdown-item>
        <el-dropdown-item>发起工单</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dropdown @command="handlePrintCommand">
      <el-button size="mini" type="primary">
        打印标签<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in waybilllabels" :key="item.ChannelLabelId" :command="item.ChannelLabelId">{{item.ChannelLabelName}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div v-show="searchshow" class="div-top">
      <el-form v-model="search" label-width="150px" class="etms-search-form">
        <el-form-item label="运单状态：" class="fl">
          <el-select size="mini" placeholder="请选择运单状态" v-model="search.waybillstate" class="el-width-200" filterable clearable>
            <el-option v-for="item in waybillstates" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发货商：" class="fl">
          <el-select size="mini" placeholder="请选择发货商" v-model="search.shippers" filterable clearable class="el-width-200"></el-select>
        </el-form-item>
        <el-form-item label="渠道：" class="fl">
          <el-select size="mini" placeholder="请选择运输渠道" v-model="search.channel" filterable clearable class="el-width-200"></el-select>
        </el-form-item>
        <el-form-item label="目的国家：" class="fl">
          <el-select size="mini" placeholder="请选择目的国家" v-model="search.purposeregion" filterable clearable class="el-width-200"></el-select>
        </el-form-item>
        <el-form-item label="目的机场：" class="fl">
          <el-select size="mini" placeholder="请选择目的机场" v-model="search.purposeair" filterable clearable class="el-width-200"></el-select>
        </el-form-item>
        <el-form-item label="目的港口：" class="fl">
          <el-select size="mini" placeholder="请选择目的港口" v-model="search.purposeport" filterable clearable class="el-width-200"></el-select>
        </el-form-item>
        <el-form-item label="目的仓库：" class="fl">
          <el-select size="mini" placeholder="请选择目的仓库" v-model="search.purposedepot" filterable clearable class="el-width-200"></el-select>
        </el-form-item>
        <el-form-item label="卖家ID：" class="fl">
          <el-input size="mini" placeholder="请填写平台卖家ID" v-model="search.sellercode" class="el-width-200"></el-input>
        </el-form-item>
        <el-form-item label="打印状态：" class="fl">
          <el-select size="mini" placeholder="请选择打印状态" v-model="search.printstate" filterable clearable class="el-width-200">
            <el-option v-for="item in waybillprintstates" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="fl">
          <template slot="label">
            <el-select size="mini" placeholder="时间分类" v-model="search.waybilltimetype" filterable class="el-width-100 el-padding-right-10">
              <el-option v-for="item in waybilltimetypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </template>
          <el-date-picker size="mini" v-model="search.timeslot" type="datetimerange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" class="el-width-200">
          </el-date-picker>
        </el-form-item>
        <el-form-item class="fl">
          <template slot="label">
            <el-select size="mini" placeholder="单号分类" v-model="search.oddtype" filterable class="el-width-110 el-padding-right-10">
              <el-option v-for="item in oddtypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </template>
          <el-input size="mini" type="textarea" :rows="3" placeholder="请输入单号" v-model="search.odd" class="el-width-200 textarea-padding-top"></el-input>
        </el-form-item>
        <el-form-item class="fl">
          <el-button type="primary" icon="el-icon-search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="clear"></div>
    <div class="div-list">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageindex" :page-sizes="pagesizes" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="recordcount"></el-pagination>
      <el-table :data="waybilllist" :border="true" @selection-change="handleSelectionChange" class="etms-router-list">
        <el-table-column type="selection" width="40px" header-align="center" align="center" prop="WaybillId">
        </el-table-column>
        <el-table-column label="客户单号" align="center" prop="CustomerOdd"></el-table-column>
        <el-table-column label="服务商单号" align="center" prop="ServiceOdd"></el-table-column>
        <el-table-column label="追踪单号" align="center" prop="TrackOdd"></el-table-column>
        <el-table-column label="发货商" align="center" prop="TargetEnterpriseName"></el-table-column>
        <el-table-column label="渠道" align="center" prop="ChannelName"></el-table-column>
        <el-table-column label="收货人" align="center" prop="ReceiptName"></el-table-column>
        <el-table-column label="目的国家" align="center" prop="PurposeRegion"></el-table-column>
        <el-table-column label="创建时间" align="center" prop="FirstEditTime"></el-table-column>
        <el-table-column label="抓单时间" align="center" prop="ConfirmTime"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="查看运单详细信息" placement="top">
              <el-button size="mini" @click="handleView(scope.$index,scope.row)" icon="el-icon-view" circle></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="修改运单信息" placement="top">
              <el-button size="mini" type="primary" @click="handleEdit(scope.$index,scope.row)" icon="el-icon-edit-outline" circle></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      waybilllabels: [
        {
          ChannelLabelId: '123456',
          ChannelLabelName: '中邮挂号-A4'
        }
      ],
      oddtypes: this.constant.oddtypes,
      waybilltimetypes: this.constant.waybilltimetypes,
      searchshow: false,
      waybillids: [],
      waybillstates: this.constant.waybillstates,
      waybillprintstates: this.constant.waybillprintstates,
      taglist: this.constant.taglist,
      pagesizes: this.constant.pagesizes,
      pageindex: 1,
      pagesize: 100,
      recordcount: 0,
      pickerOptions: this.constant.pickerOptions,
      search: {
        oddtype: 'serviceodd',
        odd: '',
        shippers: '',
        channel: '',
        purposeregion: '',
        purposeport: '',
        purposedepot: '',
        sellercode: '',
        waybilltimetype: 'firstedittime',
        timeslot: '',
        waybillstate: ''
      },
      waybilllist: [
        {
          WaybillId: '1111111',
          CustomerOdd: '1234567891231',
          ServiceOdd: '4566154561616',
          TrackOdd: '4566154561616',
          TargetEnterpriseName: '广州凯捷物流供应链',
          ChannelName: '广州小包线下仓',
          PurposeRegion: '美国',
          ReceiptName: 'ethan-xiangnan',
          FirstEditTime: '2018-12-02 00:00:10',
          ConfirmTime: '2018-12-02 00:00:30'
        },
        {
          WaybillId: '222222',
          CustomerOdd: '1234567891231',
          ServiceOdd: '4566154561616',
          TrackOdd: '4566154561616',
          TargetEnterpriseName: '广州凯捷物流供应链',
          ChannelName: '广州小包线下仓',
          PurposeRegion: '美国',
          ReceiptName: 'ethan-xiangnan',
          FirstEditTime: '2018-12-02 00:00:10',
          ConfirmTime: '2018-12-02 00:00:30'
        }
      ]
    }
  },
  mounted () {
    this.initTagTotal()
  },
  methods: {
    initTagTotal () {
      var tag = this.taglist.filter(item => item.class === 'active')[0];
      if (tag !== null && tag !== undefined) {
        this.tagClick(tag)
      }
    },
    tagClick (tag) {
      this.taglist.forEach((item, index) => {
        item.class = ''
      })
      tag.class = 'active'

      switch (tag.value) {
        case 'halfyear':
          const end = new Date()
          const start = new Date()
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
          this.search.timeslot = [start, end]
          break;

        default:
          this.search.waybillstate = tag.value
          break;
      }
    },
    handleCommand (command) {
      this.$message('click on item ' + command);
    },
    handlePrintCommand (command) { },
    handleSelectionChange (val) {
      this.waybillids = val;
      this.waybillids.forEach((item, index) => {
        alert(item.WaybillId)
      })
    },
    handleView (index, row) { },
    handleEdit (index, row) { },
    handleSizeChange (val) { },
    handleCurrentChange (val) { },
  }
}
</script>

<style scoped>
@import "../../../css/etms/home.css";
@import "../../../css/iconfont.css";

.etms-router-body ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.etms-router-body .tag-span {
  cursor: pointer;
  padding: 5px 20px;
  line-height: 30px;
  border: 1px solid #ffffff;
  font-size: 16px;
  font-weight: 700;
}
.etms-router-body .tag-span:hover {
  border: 1px solid #409eff;
}

.etms-router-body .tag-span.active {
  color: #409eff;
}

.etms-router-body .div-top {
  margin-top: 20px;
  border-top: 1px solid #dcdfe6;
}

.etms-router-body .div-list {
  margin-top: 20px;
}

.etms-router-body .textarea-padding-top {
  padding-top: 7px;
}

.etms-router-body .el-padding-right-10 {
  padding-right: 5px;
}

.etms-router-body .el-width-110 {
  width: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/etms/ctms/my_waybill.vue